import React, { createContext, useContext } from "react"
import { useUnreadNotes } from "@/hooks/useUnreadNotes"
import type { UserRole } from "@/types/reports"

interface UnreadNotesContextType {
	unreadCount: number
	loading: boolean
	refreshUnreadCount: () => void
	error: string | null
}

const UnreadNotesContext = createContext<UnreadNotesContextType | undefined>(undefined)

interface UnreadNotesProviderProps {
	children: React.ReactNode
	userId?: string
	userRole?: UserRole
	userOrganizationId?: string
}

export const UnreadNotesProvider: React.FC<UnreadNotesProviderProps> = ({ children, userId, userRole, userOrganizationId }) => {
	const { unreadCount, loading, error, refreshUnreadCount } = useUnreadNotes({
		userId,
		userRole,
		userOrganizationId,
	})

	const value: UnreadNotesContextType = {
		unreadCount,
		loading,
		refreshUnreadCount,
		error,
	}

	return <UnreadNotesContext.Provider value={value}>{children}</UnreadNotesContext.Provider>
}

export const useUnreadNotesContext = (): UnreadNotesContextType => {
	const context = useContext(UnreadNotesContext)
	if (context === undefined) {
		throw new Error("useUnreadNotesContext must be used within an UnreadNotesProvider")
	}
	return context
}
